import {useEffect} from 'react';
import {
  BOTTOM_SHEET_CLOSE_FUNCTION_PREFIX,
  BOTTOM_SHEET_CONTAINER,
  BOTTOM_SHEET_DESTROY_FUNCTION_PREFIX,
  BOTTOM_SHEET_READY_FUNCTION_PREFIX,
} from '@shared/cci/features/webviewUtils';
import {addLifeCycleListener, LifeCycleState, removeLifeCycleListener} from '@shared/cci/features/webviewHook';

function BlankBottomSheetPage() {
  useEffect(() => {
    const uid = location.hash;
    window.opener[`${BOTTOM_SHEET_READY_FUNCTION_PREFIX}${uid}`]();

    return () => {
      window.opener[`${BOTTOM_SHEET_DESTROY_FUNCTION_PREFIX}${uid}`]();
    };
  }, []);

  useEffect(() => {
    const uid = location.hash;

    function appLifeCycleListener(state: LifeCycleState) {
      if (state === LifeCycleState.DESTROY) {
        window.opener[`${BOTTOM_SHEET_CLOSE_FUNCTION_PREFIX}${uid}`](false);
      }
    }

    addLifeCycleListener(appLifeCycleListener);

    return () => {
      removeLifeCycleListener(appLifeCycleListener);
    };
  }, []);
  return <div id={BOTTOM_SHEET_CONTAINER}></div>;
}

export default BlankBottomSheetPage;
